import {
  Breadcrumbs as MUIBreadcrumbs,
  Link,
  Typography,
} from "@material-ui/core";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const BreadCrumbs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = location;
  const pathnames = pathname.split("/").filter((el: string) => el);

  const pathList = [
    {
      path: "modules",
      name: "Список модулей",
    },
    {
      path: "module",
      name: "Модуль",
    },
    {
      path: "topic",
      name: "Тема",
    },
    {
      path: "test",
      name: "Промежуточный тест",
    },
    {
      path: "certificat_test",
      name: "Тест на сертификат",
    },
    {
      path: "intro_test",
      name: "Вводный тест",
    },
    {
      path: "result",
      name: "Результат",
    },
    {
      path: "author_courses",
      name: "Авторы",
    },
    {
      path: "course",
      name: "Курс",
    },
    {
      path: "account",
      name: "Мои курсы",
    },
  ];

  return (
    <div className="bread">
      <MUIBreadcrumbs aria-label="breadcrumb">
        <Link
          style={{ cursor: "pointer", color: "#9ca3af" }}
          onClick={() => window.open("https://emir.gov.ru/", "_self")}
        >
          Главная
        </Link>
        {pathname === "/" ? (
          <Typography style={{ color: "#333333" }}>Онлайн курсы</Typography>
        ) : (
          <Link
            style={{ cursor: "pointer", color: "#9ca3af" }}
            onClick={() => navigate("/")}
          >
            Онлайн курсы
          </Link>
        )}
        {pathnames.map((pathname: string, index: number) => {
          const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
          const isLast = index === pathnames.length - 1;
          return isLast ? (
            <Typography style={{ color: "#333333" }}>
              {pathList.map((item) => {
                if (item.path === pathname) {
                  return item.name;
                }
              })}
            </Typography>
          ) : (
            <Link
              style={{ cursor: "pointer", color: "#9ca3af" }}
              key={index}
              onClick={() => navigate(routeTo)}
            >
              {pathList.map((item) => {
                if (item.path === pathname) {
                  return item.name;
                }
              })}
            </Link>
          );
        })}
      </MUIBreadcrumbs>
    </div>
  );
};

export default BreadCrumbs;
